module.exports = __webpack_public_path__ + "static/media/trompete_2.cbd205fd.png";